import { get } from 'lodash';
import { type IHydrateWidgetInput } from '../../../../../hydrate/IHydrationContext.ts';
import { type IBaseWidget } from '../../../IBaseWidget.ts';
import { type IWidgetAdvancedOptionValue } from '../advanced-select-common/form/createAdvancedSelectValueSchema.ts';
import { type IAdvancedSelectWidget } from '../advanced-select-common/IAdvancedSelectWidget.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';

/**
 * Funzione di idratazione del widget di selezione multipla avanzata.
 * Legge l'array di oggetti completi dal campo principale e restituisce un
 * array di label. Le colonne RichText mantengono l'HTML originale: il
 * renderer del PDF lo interpreta.
 */
export function hydrateAdvancedMultiSelectWidget<
  W extends IBaseWidget &
    Pick<IAdvancedSelectWidget, 'labelFieldColumns' | 'columns' | 'code'>,
>(input: IHydrateWidgetInput<W>) {
  const { context, path } = input;

  // Leggiamo dal campo principale che contiene l'array di oggetti completi
  const selectedObjects: IWidgetAdvancedOptionValue[] =
    get(context.values, path) || [];

  if (!Array.isArray(selectedObjects) || selectedObjects.length === 0) {
    return { value: undefined };
  }

  const labels = selectedObjects
    .map(rowData => {
      if (!rowData || typeof rowData !== 'object') return null;

      return renderAdvancedSelectedOptionLabel(
        rowData,
        input.widget.labelFieldColumns,
        input.widget.columns,
        { keepRichTextHtml: true },
      );
    })
    .filter(Boolean);

  return { value: labels.length > 0 ? labels : undefined };
}
